import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Dot from '@hydra/common/components/Dot';
import { getContrastedColor, getPriSecColors } from '@hydra/utils/colors';
import { useReviewContext } from '@hydra/common/context/review';
import { usePdfTemplateContext } from '@hydra/common/context/pdfTemplate';

const useStyles = makeStyles(theme => ({
  root: {
    breakInside: 'avoid',
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: 0
    }
  },
  dot: {
    marginRight: theme.spacing(1)
  },
  modern: {
    paddingLeft: theme.spacing(3)
  }
}));

export const CriteriumCompetitors = ({ competitors }) => {
  const classes = useStyles();
  const { isPdf } = useReviewContext();
  const { templateColors, pdfTheme } = usePdfTemplateContext();
  const { primary, secondary } = isPdf
    ? templateColors
    : getPriSecColors();
  const color = getContrastedColor(primary);
  const isModern = isPdf && pdfTheme === 'modern';

  return competitors.map((competitor, index) => {
    if (!competitor) {
      return null;
    }
    const { component, url } = competitor;
    const currentColor = index ? secondary[index - 1] : color;
    const style = isModern
      ? { borderLeft: `3px solid ${currentColor}` }
      : { borderLeft: '0px !important' };
    return (
      <div className={classnames(classes.root, isModern && classes.modern)} style={style} key={index}>
        {component}
        <div>
          {isModern
            ? <p>{url}</p>
            : (
              <>
                <span className={classes.dot}>
                  <Dot color={currentColor} />
                </span>
                {url}
              </>
              )}
        </div>
      </div>
    );
  });
};

CriteriumCompetitors.propTypes = {
  competitors: PropTypes.array
};

export default CriteriumCompetitors;
